import React, { Component } from "react";
import HcsGroup from "./hcs-group";
import HcsSubconfigControls from "./hcs-subconfig-controls";
import { ConfigurationModes } from "./hcs-constants";

export default class HcsSubConfigInline extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            currentVisibleIndex: 0
        };

        this.changeTab = this.changeTab.bind(this);
        this.configure = this.configure.bind(this);
    }

    changeTab(e, callback) {
        const { data, hcs } = this.props;

        let args = arguments;
        let newIndex;

        switch(typeof e) {
            case "number":
                newIndex = e;
                break;

            default:
                newIndex = parseInt(e.currentTarget.getAttribute("idx"));
                break;
        }

        hcs.api.subconfigurationChangedTrigger(data.ident, newIndex);

        this.setState({
            currentVisibleIndex: newIndex
        }, () => {
                if(args.length > 1) {
                    callback();
                }
        });
    }

    configure(method, attrName, attrValue, cfgItem, options) {
        let self = this;
        const { data } = this.props;
        const { currentVisibleIndex } = this.state;

        let opts = Object.assign({}, {
            success: function() { }
        }, options);

        this.props.onConfig(method, attrName, attrValue, {
            subConfigName: data.ident,
            subConfigIndex: cfgItem.info.index,
            success: (result) => {
                switch(method) {
                    case "AddSubCfg":
                        // Switch to recently added subconfiguration
                        self.changeTab(data.cfgobjs.length);
                        break;

                    case "DeleteSubCfg":
                        // Switch one tab back when last subconfiguration is selected and then being removed
                        if(currentVisibleIndex >= data.cfgobjs.length - 1) {
                            self.changeTab(currentVisibleIndex - 1);
                        } 
                        break;
                }

                opts.success.call(self, result);
            }
        });
    }

    render() {
        const { data, hcs } = this.props;
        const { currentVisibleIndex } = this.state;

        let cfgItem = data.cfgobjs[currentVisibleIndex];

        return cfgItem ?
            <li className="hcs-sub-config-inline">
                <h3>{hcs.t.ecs(data.ident)}</h3>
                <nav> {
                    data.cfgobjs.map((cfgItem, index) => {
                        let buttonClasses = [];

                        if(index === currentVisibleIndex) {
                            buttonClasses.push("hcs-current");
                        }

                        return (
                            <button
                                key={`hcs-subcfg-nav-${data.ident}-${index}`}
                                idx={index}
                                onClick={(e) => this.changeTab(e)}
                                className={buttonClasses.length ? buttonClasses.join(" ") : null}
                            >
                                <em>{index + 1}</em>
                                <span>{cfgItem.data.NAME_TRANS}</span>
                            </button>);
                        }
                    )}
                </nav>
                <HcsSubconfigControls
                    hcs={this.props.hcs}
                    data={data}
                    controlAdd="AddSubCfg"
                    controlDelete="DeleteSubCfg"
                    onConfig={(method) => { this.configure(method, null, null, cfgItem); }}
                />
                <div key={`hcs-subcfg-group-${data.ident}-${currentVisibleIndex}`}>
                    <HcsGroup
                        data={cfgItem}
                        groupGetTitle={(data) => { return this.groupGetTitle(data); }}
                        hcs={this.props.hcs}
                        subConfigInfo={{
                            subConfigMode: ConfigurationModes.SubConfigurationInline,
                            isSubConfig: false,
                            subConfigName: null,
                            subConfigDescription: null
                        }}
                        onConfig={(method, attrName, attrValue, options) => { this.configure("setSubCfgValue", attrName, attrValue, cfgItem, options); }}
                        configWait={this.props.configWait}
                        checkValueChange={this.props.checkValueChange} />
                </div>
            </li> : null;
    }
}
